var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"mt-4",attrs:{"cols":"12"}},[_c('v-progress-circular',{staticClass:"mx-auto",staticStyle:{"display":"block"},attrs:{"size":50,"width":5,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }